module.exports = __webpack_public_path__ + "70fdb0e0a14818aeaaca64de88170e83.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/image/Background.jpg
// module id = 228
// module chunks = 0